import React, { Component } from 'react';
import moment from 'moment';
import './App.css';
import { readJSON } from './helpers';
import GridHeatmap, { YELLOW_COLOR } from './components/grid-heatmap';
import { getDateFromString } from './utils/date-time-utils';
import ChartLegend from './components/chart-legend';

const Y_LABELS = ['graphql', 'authorize', 'requestAccessToken', 'linkExternalAccount', 'changePassword',
  'mqttTracking', 'tracking'];
const ENVS = ['dev', 'cn', 'main'];
const MAX_DAYS = 30;

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      xLabels: [],
      yLabels: Y_LABELS,
      data: []
    }
  }

  componentDidMount() {
    readJSON().then(({ data }) => {
      const dateKeys = Object.keys(data.cn.authorize)
        .slice(-MAX_DAYS)
        .sort((date1Str, date2Str) => {
          const date1 = getDateFromString(date1Str);
          const date2 = getDateFromString(date2Str);
          return date2.getTime() - date1.getTime();
        });
      const xLabels = dateKeys.map((dateStr => moment(getDateFromString(dateStr)).format('DD/MM')));

      const displayData = ENVS.map((env) => {
        return ({
          env: env,
          data: (new Array(Y_LABELS.length)).fill(0)
            .map((i, yIndex) =>
              (new Array(xLabels.length)).fill(0).map((j, xIndex) => {
                const api = Y_LABELS[yIndex];
                const date = dateKeys[xIndex];
                return data[env][api][date].length > 0 ?
                  (data[env][api][date].filter((r) => r).length / data[env][api][date].length) * 100 : 100
              }))
        });
      });

      this.setState({
        xLabels: xLabels,
        data: displayData
      });
    });
  }

  render() {
    return (
      <div
        style={{
          padding: 24,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row-reverse',
            width: '100%',
          }}
        >
          <ChartLegend color='red' description='Service Disruption' />
          <ChartLegend color={YELLOW_COLOR} description='Performance Issue' />
          <ChartLegend color='green' description='Performance Checked' />
        </div>
        {this.state.data.map((data) => (
          <div style={{
            marginBottom: 12,
          }}>
            <h2>{data.env}</h2>
            <GridHeatmap
              xLabels={this.state.xLabels}
              yLabels={Y_LABELS}
              data={data.data}
            />
          </div>
        ))}
      </div>
    );
  }
}

export default App;
